type DeletionCheck = {
  isActive: boolean;
  memberCount: number;
  publicationCount: number;
};

const count = (n: number, one: string, many: string) =>
  `${n} ${n === 1 ? one : many}`;

/**
 * Una audiencia solo puede eliminarse si ya no la usa nadie: borrarla con
 * miembros o publicaciones dejaría IDs apuntando a una audiencia inexistente y
 * ese contenido sin forma de administrarse. Devuelve el motivo del bloqueo, o
 * null si puede eliminarse.
 */
export function getDeletionBlock({
  isActive,
  memberCount,
  publicationCount,
}: DeletionCheck): string | null {
  if (isActive) {
    return 'Desactiva la audiencia antes de eliminarla.';
  }

  const reasons: string[] = [];
  if (memberCount > 0) {
    reasons.push(
      `tiene ${count(memberCount, 'miembro', 'miembros')}; quítalos desde "Miembros"`,
    );
  }
  if (publicationCount > 0) {
    reasons.push(
      `está referenciada por ${count(publicationCount, 'publicación', 'publicaciones')}`,
    );
  }
  if (reasons.length === 0) return null;

  return `No se puede eliminar: la audiencia ${reasons.join(' y ')}.`;
}
